import React, { createContext, useState } from 'react'
import CreateBattery from './CreateBattery'

export const CreateBatteryContext = createContext()

const CreateBatteryPage = () => {
    const [selectedAssessmentDefs, setSelectedAssessmentDefs] = useState([])
    const [assessmentFilters, setAssessmentFilters] = useState({ category: null })
    const [name, setName] = useState('')
    const [label, setLabel] = useState('')
    const [intendedFor, setIntendedFor] = useState(null)

    const value = {
        selectedAssessmentDefs, setSelectedAssessmentDefs,
        assessmentFilters, setAssessmentFilters,
        name, setName,
        label, setLabel,
        intendedFor, setIntendedFor,
    }

    return (
        <CreateBatteryContext.Provider value={value}>
            <CreateBattery />
        </CreateBatteryContext.Provider>
    )
}

export default CreateBatteryPage
